import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ConfigService } from '@bo-client/config/config.service';

@Component({
  selector: 'app-get-iban',
  templateUrl: './get-iban.component.html',
  styleUrls: ['./get-iban.component.scss']
})
export class GetIbanComponent implements OnInit, OnDestroy {
  @Input() inputForm: FormGroup;
  public dataForm$: Observable<any>;
  private compUnsubs$ = new Subject<void>();
  public errorText = '';
  public bankName = null;
  public ibanIsRequired = false;
  private ibanIsValid: boolean;

  constructor(private httpHapService: HttpHapService, public configService: ConfigService) {}

  ngOnInit(): void {
    this.ibanIsRequired = this.inputForm.get('iban').hasValidator(Validators.required);
    this.setValidators(this.ibanIsRequired);
    this.changeFormValues();
  }

  changeFormValues() {
    this.dataForm$ = this.inputForm.get('iban').valueChanges.pipe(
      takeUntil(this.compUnsubs$),
      // Warum filtern wir hier auf string is null or empty?
      filter((val: string) => val != null && val.replace(/ /g, '').length > 1),
      switchMap((val) =>
        this.httpHapService.httpClientback
          .post(this.configService.getSettings('ibanCheckApi'), { iban: val.replace(/ /g, '').toUpperCase() })
          .pipe(
            tap((answer: any) => {
              this.ibanIsValid = answer.payload.status.toLowerCase() === 'valid';
              console.log('setting is Iban valud', this.ibanIsValid);
              if (this.ibanIsValid) {
                // this.changeFormValues();
                this.inputForm.get('iban').patchValue(answer.payload.ibanReadable, { emitEvent: false });
                this.inputForm.get('iban').updateValueAndValidity({ emitEvent: false });
                this.inputForm.get('bic').patchValue(answer.payload.bic);
                this.inputForm.get('bankName').patchValue(answer.payload.bankName);
              } else {
                this.inputForm.get('bic').patchValue(null);
                this.inputForm.get('bankName').patchValue(null);
              }
            })
          )
      )
    );
  }

  pasteValue(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');
    setTimeout(() => {
      this.inputForm.get('iban').patchValue(pastedText);
    }, 500);
  }

  setValidators(isRequired: boolean) {
    this.inputForm
      .get('iban')
      .setValidators(
        isRequired ? [Validators.required, this.isValidIbanValidator()] : [this.isValidIbanValidator()]
      );
  }

  private isValidIbanValidator(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      console.log('eval is valid iban', this.ibanIsValid);
      if (!this.ibanIsValid) {
        return { iban: true };
      }
      return null;
    };
  }

  showErrorInField() {
    this.errorText = this.iban.errors?.['required'] ? 'IBAN ist erforderlich' : 'IBAN ist nicht gültig';
  }

  get iban() {
    return this.inputForm.get('iban') as FormControl;
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
